import { defineComponent, ref, Teleport, Transition, watch } from "vue";

import "./popup.less";

export default defineComponent({
  emits: ["update:visible"],
  props: {
    visible: { type: Boolean, default: false },
    position: { type: String, default: "center" },
    overlay: { type: Boolean, default: true },
    width: { type: [String, Number], default: "auto" },
    height: { type: [String, Number], default: "auto" },
    maxWidth: { type: [String, Number], default: "100%" },
    maxHeight: { type: [String, Number], default: "100%" },
    overlayClass: { type: [String, Array, Object], default: "" },
    contentClass: { type: [String, Array, Object], default: "" },
    closeOnOverlayClick: { type: Boolean, default: false },
  },
  setup(props, { slots, attrs, emit }) {
    const visible = ref(false);
    const zIndex = ref(-1);

    const onOverlayClick = () => {
      if (!props.closeOnOverlayClick) return;
      emit("update:visible", false);
    };

    const onAfterLeave = () => {
      visible.value = false;
    };

    watch(
      () => props.visible,
      () => {
        visible.value = props.visible;
        window.__NEBULA_WEB_SDK__.zIndex += 1000;
        zIndex.value = window.__NEBULA_WEB_SDK__.zIndex;
      },
    );

    const renderOverlayNode = () => {
      if (!props.overlay) return null;
      return (
        <Transition appear={true} name="feiyu-web-popup--overlay">
          <div
            class={["feiyu-web-popup--overlay", props.overlayClass]}
            style={{ zIndex: zIndex.value + 100 }}
            v-show={visible.value}
            onClick={onOverlayClick}
          />
        </Transition>
      );
    };

    const renderContentNode = () => {
      return (
        <Transition
          appear={true}
          name={`feiyu-web-popup--position-${props.position}`}
          onAfterLeave={onAfterLeave}
        >
          <div
            class={["feiyu-web-popup--content", props.contentClass]}
            style={{
              zIndex: zIndex.value + 1000,
              maxWidth: typeof props.maxWidth === "string" ? props.maxWidth : `${props.maxWidth}px`,
              maxHeight:
                typeof props.maxHeight === "string" ? props.maxHeight : `${props.maxHeight}px`,
              width: typeof props.width === "string" ? props.width : `${props.width}px`,
              height: typeof props.height === "string" ? props.height : `${props.height}px`,
            }}
            v-show={visible.value}
          >
            {slots.default?.()}
          </div>
        </Transition>
      );
    };

    return () => (
      <Teleport to="body">
        <div
          class={["feiyu-web-popup", `feiyu-web-popup--position-${props.position}`, attrs.class]}
          style={{ zIndex: zIndex.value }}
        >
          {renderOverlayNode()}
          {renderContentNode()}
        </div>
      </Teleport>
    );
  },
});
